import { useContext, useState } from 'react';
import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';
import Text from '../../../../Text';
import { SURVEY_FREE_RESPONSE_CHARACTER_LIMIT } from '../../../data';
import CharacterCount from '../components/CharacterCount.jsx';
import i18n from '../../../../../app/i18n';
import { Button } from '../../../../FormStyles/Button';
import ToggleWrapper from '../components/ToggleWrapper';
import ToggleSwitch from '../../../../FormStyles/ToggleSwitch.jsx';
import { InteractionContext } from '../../../contexts';

const FreeResponse = () => {
  const { values, handleChange } = useContext(InteractionContext);
  const [response, setResponse] = useState('');

  return (
    <>
      <ResponseLabelWrapper>
        <ResponseLabel>
          {i18n.t(
            'tileForm:interaction.types.survey.free_response.textArea.label',
          )}
        </ResponseLabel>
        <CharacterCount
          characterLimit={SURVEY_FREE_RESPONSE_CHARACTER_LIMIT}
          characters={response.length}
        />
      </ResponseLabelWrapper>
      <ResponseInput
        maxLength={SURVEY_FREE_RESPONSE_CHARACTER_LIMIT}
        placeholder={i18n.t(
          'tileForm:interaction.types.survey.free_response.textArea.placeholder',
        )}
        onChange={({ target: { value } }) => setResponse(value)}
      />
      <SubmitButton variant="answerBlue" type="button">
        {i18n.t('tileForm:interaction.types.survey.free_response.buttonText')}
      </SubmitButton>
      <ToggleWrapper>
        <ToggleSwitch
          value={values.isAnonymous}
          onChange={handleChange}
          name="isAnonymous"
          id="isAnonymous"
          label={i18n.t('tileForm:interaction.toggleLabels.makeTileAnonymous')}
          color="black.80"
          fontWeight="400"
          margin="0 0 10px 0"
          invertLabelPosition
        />
      </ToggleWrapper>
    </>
  );
};

export default FreeResponse;

const SubmitButton = styled(Button)`
  width: 100%;
  background: linear-gradient(
    253.58deg,
    ${themeGet('colors.primary.70')} 1.55%,
    ${themeGet('colors.primary.100')} 95.8%
  );
  font-size: 20px;
  line-height: 25px;
  min-height: 45px;
  padding: 10px 20px;
  font-weight: 400;

  &:hover {
    background: linear-gradient(
      253.58deg,
      ${themeGet('colors.primary.70')} 1.55%,
      ${themeGet('colors.primary.80')} 95.8%
    );
  }
  &:active {
    background: linear-gradient(
      253.58deg,
      ${themeGet('colors.primary.70')} 1.55%,
      ${themeGet('colors.primary.100')} 95.8%
    );
    box-shadow: none;
  }
`;

const ResponseLabelWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ResponseLabel = styled(Text)`
  font-size: 14px;
  color: ${themeGet('colors.black.80')};
  margin: 0 3px;
`;

const ResponseInput = styled.textarea`
  height: 100px;
  padding: 11px;
  font-size: 14px;
  resize: none;
`;
